import { StyleSheet } from 'react-native';
import { COLORS, FONTS } from '../../constants';

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginVertical: 30,
  },
  selectWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 20,
  },
  selectedText: {
    fontSize: 15,
    fontFamily: FONTS.AvenirMedium,
    color: COLORS.GREEN,
    fontWeight: '500',
    textTransform: 'uppercase',
  },
  selectedBox: {
    width: 17,
    height: 17,
    borderWidth: 0.5,
    borderColor: COLORS.DARK_GREY,
    borderRadius: 2,
    marginRight: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  filterWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    borderBottomWidth: 0.5,
    borderBottomColor: COLORS.DARK_GREY,
    paddingBottom: 15,
    marginBottom: 15,
  },
  filterText: {
    fontSize: 16,
    letterSpacing: 2,
    fontFamily: FONTS.IowanOldStyleBTRoman,
    color: COLORS.GREEN,
    textTransform: 'uppercase',
  },
});
